// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1861) return "static/chunks/1861-324b494bcdd73a67.js";
	if (chunkId === 7754) return "static/chunks/7754-59ac6f508e4a7418.js";
	if (chunkId === 6427) return "static/chunks/6427-b84a42cb356577ff.js";
	if (chunkId === 9573) return "static/chunks/9573-5a9bcf94a5570838.js";
	if (chunkId === 8784) return "static/chunks/8784-30cfe7a447dc9168.js";
	if (chunkId === 3065) return "static/chunks/3065-efc95abee4e0ae2a.js";
	if (chunkId === 4110) return "static/chunks/4110-a4f590ce9938e065.js";
	if (chunkId === 8411) return "static/chunks/8411-092505b0da8365ae.js";
	if (chunkId === 8522) return "static/chunks/8522-a2feb5cf729b1341.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"302":"50898abdf437a9e4","1853":"0b6546d1aa3271f2","4427":"a8971adc7671f3c4","4980":"9643d2bd71e7acdf","5576":"b66e44efb93ab338","8373":"f8a661ed4cc8fc5d","8406":"8847f4df682279a1","8968":"2c8ebe2ac4f29502","9760":"89e02fa1b0685d21"}[chunkId] + ".js";
};